import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=af6a3802&"
import script from "./RefundDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports